<template lang="pug">
  hotsite(
    :nome="'Diretoria Gestão e Fiscalização de Contratos - DGC'"
    :tema="'theme-wine'"
    :capa="'../../../static/banner_hotsite.jpg'"
    :menu="aside_links",
    :links="footer_links",
    :breadcrumb="breadcrumb")
    template(slot="conteudo"): slot
</template>

<script>
  import Hotsite from 'MODULES/Hotsite'

  export default {

    components: {
      Hotsite
    },

    data () {
      return {
        breadcrumb: [
          { nome: 'DGC', rota: 'DGCIndex' }
        ],
        aside_links: [
          { id: 0, texto: 'Início', rota: 'DGCIndex' },
          { id: 1, texto: 'Sobre a DGC', rota: 'DGCSobre' },
          // { id: 2, texto: 'Fiscalização de Contratos', rota: 'DGCContratos' },
          { id: 3, texto: 'Orientações e manuais', rota: 'DGCOrientacoes' },
          { id: 4, texto: 'Contatos', rota: 'DGCContato' }
        ],
        footer_links: [
          { id: 0, texto: 'Primeiro Link', rota: 'DGCIndex' },
          { id: 1, texto: 'Segundo Link', rota: 'DGCIndex' },
          { id: 2, texto: 'Terceiro Link', rota: 'DGCIndex' },
          { id: 3, texto: 'Quarto Link', rota: 'DGCIndex' },
          { id: 4, texto: 'Quinto Link', url: 'http://google.com/' }
        ]
      }
    }

  }
</script>



// WEBPACK FOOTER //
// Base.vue?40813d01